import { render, staticRenderFns } from "./SingleAmazingProduct.vue?vue&type=template&id=cb3fdfa4&scoped=true"
import script from "./SingleAmazingProduct.vue?vue&type=script&lang=js"
export * from "./SingleAmazingProduct.vue?vue&type=script&lang=js"
import style0 from "./SingleAmazingProduct.vue?vue&type=style&index=0&id=cb3fdfa4&prod&scoped=true&lang=css"
import style1 from "./SingleAmazingProduct.vue?vue&type=style&index=1&id=cb3fdfa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3fdfa4",
  null
  
)

export default component.exports